import { languages } from "./languages";

export function pageT(lang, dict) {
  return dict[lang] || dict.eng;
}

function bySection(section) {
  return {
    eng: languages.eng[section],
    ar: languages.ar[section],
    fr: languages.fr[section],
    es: languages.es[section],
    sw: languages.sw[section],
  };
}

export const COMMON = bySection("common");
export const INTRO = bySection("intro");
export const LOGIN = bySection("login");
export const REGISTER = bySection("register");
export const HOME = bySection("home");
export const ACCOUNT = bySection("account");
export const LEVEL = bySection("level");
export const HISTORY = bySection("history");
export const SILVER = bySection("silver");
export const GOLDEN = bySection("golden");
export const DIAMOND = bySection("diamond");
export const FINISH = bySection("finish");
export const LEVEL_MAP = bySection("levelMap");
